import { Flex, PanelInset, Paragraph, Spinner } from '@customerio/pluma-components/react';
import { RelationshipsTableBody, type RelationshipsTableBodyProps } from './relationships-table-body';

type RelationshipsTableSectionProps = RelationshipsTableBodyProps & {
  isFetching: boolean;
  isError: boolean;
};

/** The panel's middle section: the fetch spinner, the load failure, or the table. */
export function RelationshipsTableSection({ isFetching, isError, ...body }: RelationshipsTableSectionProps) {
  if (isFetching) {
    return (
      <Flex justifyContent="center" alignItems="center" py="200">
        <Spinner shouldShowLoadingText label="Fetching relationships…" />
      </Flex>
    );
  }

  if (isError) {
    return (
      <PanelInset pb="200">
        <Paragraph variant="secondary">Could not load relationships. Try again later.</Paragraph>
      </PanelInset>
    );
  }

  return (
    <PanelInset>
      <RelationshipsTableBody {...body} />
    </PanelInset>
  );
}
